import vueDropzone from 'vue2-dropzone';
import { isObject } from 'lodash';

export default {
  components: {
    vueDropzone,
  },
  data() {
    return {
      loading: false,
      dropOptions: {
        url: () => this.fileUrl,
        dictRemoveFile: '❌',
        dictDefaultMessage: 'Drop files here to upload, or click to <span class="underline">select</span> a file to upload.',
        addRemoveLinks: true,
        autoProcessQueue: false,
        uploadMultiple: true,
        parallelUploads: 10,
        thumbnailWidth: 125,
        thumbnailHeight: 125,
        acceptedFiles: '.csv,.xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png',
        maxFilesize: 10, // MB
        headers: {
          Authorization: `Bearer ${this.$store.getters.authToken}`,
        },
        renameFile(file) {
          const fileParts = file.name.split('.');
          const extension = fileParts[fileParts.length -1].toLowerCase();
          fileParts[fileParts.length -1] = extension;
          return fileParts.join('.');
        },
      },
    };
  },
  props: {
    fileUrl: {
      default: null,
    },
  },
  methods: {
    processFiles() {
      this.loading = true;
      this.$refs.dropzone.processQueue();
    },
    validate() {
    },
    onFileSuccess(file, response) {
    },
    onFileError(file, errorMessage) {
      const text = this.formatErrorMessage(errorMessage);

      this.$refs.dropzone.removeFile(file);

      this.$notify({
        title: 'Error',
        text,
        type: 'error',
      });
      this.complete();
    },
    complete() {
      this.loading = false;
    },
    attachParams(file, xhr, formData) {
    },
    getFiles() {
      return this.$refs.dropzone.getQueuedFiles();
    },
    hasFiles() {
      return this.getFiles().length > 0;
    },
    formatErrorMessage(errorMessage) {
      const defaultMessage = 'Something went wrong. Please try again later.';

      if (!errorMessage) {
        return defaultMessage;
      }

      if (isObject(errorMessage)) {
        const { error } = errorMessage;
        if (!error) {
          return defaultMessage;
        }

        const { errors } = error;

        if (!errors || errors.length === 0) {
          return defaultMessage;
        }

        return Object.values(errors).join('\n');
      }

      return errorMessage;
    },
  },
};
